import React from 'react';
import Header from '../../components/ui/Header';
import CompanyStory from './components/CompanyStory';
import TeamProfiles from './components/TeamProfiles';
import CertificationsSection from './components/CertificationsSection';
import WhyChooseUs from './components/WhyChooseUs';
import ClientTestimonials from './components/ClientTestimonials';
import CompanyTimeline from './components/CompanyTimeline';
import CredentialsDownload from './components/CredentialsDownload';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import logo from '../../../public/assets/images/fibrelogo.png';

const AboutExpertise = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-primary/5 via-white to-accent/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full text-primary font-medium text-sm">
              <Icon name="Award" size={16} />
              <span>Trusted Infrastructure Partner Since 2015</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-text-primary">
              About <span className="text-primary">Xtreem Fibre Solutions</span>
            </h1>
            
            <p className="text-xl text-text-secondary max-w-4xl mx-auto leading-relaxed">
              We're not just telecommunications contractors—we're strategic technology enablers who transform businesses through superior fiber optic infrastructure. Our expertise, certifications, and proven track record make us the trusted partner for critical connectivity transformations.
            </p>
            
            {/* <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
              <Button
                variant="default"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="cta-primary"
              >
                Schedule Consultation
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Download"
                iconPosition="left"
                className="trust-glow"
              >
                Download Credentials
              </Button>
            </div> */}
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-12">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">500+</div>
                <div className="text-sm text-text-secondary">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">8+</div>
                <div className="text-sm text-text-secondary">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">99.9%</div>
                <div className="text-sm text-text-secondary">Success Rate</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">24/7</div>
                <div className="text-sm text-text-secondary">Support Available</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Company Story */}
      <CompanyStory />
      {/* Team Profiles */}
      <TeamProfiles />
      {/* Certifications */}
      <CertificationsSection />
      {/* Why Choose Us */}
      <WhyChooseUs />
      {/* Client Testimonials */}
      <ClientTestimonials />
      {/* Company Timeline */}
      <CompanyTimeline />
      {/* Credentials Download */}
      {/* <CredentialsDownload /> */}
      {/* CTA Section */}
      <section className="py-16 bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold">
              Ready to Transform Your Infrastructure?
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Partner with Xtreem Fibre for your next fiber optic project. Our expertise, certifications, and proven track record ensure your success.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
              {/* <Button
                variant="secondary"
                size="lg"
                iconName="Phone"
                iconPosition="left"
                className="bg-white text-primary hover:bg-white/90"
              >
                Call: 01483 343 064
              </Button> */}
              <Button
                variant="outline"
                size="lg"
                iconName="MessageSquare"
                iconPosition="left"
                className="border-white text-white hover:bg-white hover:text-primary"
                onClick={() => window.location.href = '/get-quote-consultation'}
              >
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8">
                  {/* Company Info */}
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <img
                                      src={logo}
                                          alt="Xtreem Fibre Solutions"
                                          width={80}
                                          height={80}
                                          className="h-16 w-auto brightness-0 invert transition-transform duration-300 group-hover:scale-105"/>
                                      
                      <div>
                        <h3 className="text-lg font-bold">Xtreem Fibre Solutions</h3>
                        <p className="text-xs text-slate-400 font-mono">Infrastructure Transformation</p>
                      </div>
                    </div>
                    <p className="text-slate-300 text-sm leading-relaxed">
                      Transforming businesses through future-ready fiber optic infrastructure. 
                      Seamless transitions, minimal disruption, maximum performance.
                    </p>
                  </div>
      
                  {/* Services */}
                  <div>
                    <h4 className="font-semibold mb-4">Services</h4>
                    <ul className="space-y-2 text-sm text-slate-300">
                        <li><a href="/copper-to-fiber-conversion-service" className="hover:text-white transition-colors">Fibre Optics</a></li>
                      <li><a href="/network-assessment-tool" className="hover:text-white transition-colors">Technical Support</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Emergency Support</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Maintenance Plans</a></li>
                    </ul>
                  </div>
      
                  {/* Company */}
                  <div>
                    <h4 className="font-semibold mb-4">Company</h4>
                    <ul className="space-y-2 text-sm text-slate-300">              
                      <li><a href="/about-expertise" className="hover:text-white transition-colors">About Us</a></li>
                      <li><a href="/service-areas-local-teams" className="hover:text-white transition-colors">Service Areas</a></li>
                      <li><a href="/get-quote-consultation" className="hover:text-white transition-colors">Contact Us</a></li>                
                    </ul>
                  </div>
      
                  {/* Contact */}
                  <div>
                    <h4 className="font-semibold mb-4">Contact</h4>
                    <div className="space-y-3 text-sm text-slate-300">
                      <div>
                        <p className="font-medium text-white">Emergency: 24/7</p>
                        <p>01483 343 064</p>
                      </div>
                      <div>
                        <p className="font-medium text-white">General Inquiries</p>
                        <p>admin@xtreemfibresolutions.co.uk</p>
                      </div>
                      <div>
                        <p className="font-medium text-white">Business Hours</p>
                        <p>Mon-Fri: 8AM-6PM EST</p>
                      </div>
                    </div>
                  </div>
                </div>
      
                <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
                  <p className="text-slate-400 text-sm">
                    © {new Date()?.getFullYear()} Xtreem Fibre Solutions. All rights reserved.
                  </p>
                  <div className="flex space-x-6 mt-4 md:mt-0">
                    {/* <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Privacy Policy</a> */}
                    <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Terms of Service</a>
                    {/* <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Cookie Policy</a> */}
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default AboutExpertise;